// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    roleId: z.string().min(1).max(21),
    scopeId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    roleId: z.string().min(1).max(21),
    scopeId: z.string().min(1).max(21),
});
export const RolesScopes = Object.freeze({
    table: 'roles_scopes',
    tableSingular: 'roles_scope',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        roleId: 'role_id',
        scopeId: 'scope_id',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'roleId',
        'scopeId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
